const enc = new TextEncoder();

export async function sha256(str: string) {
  const buf = await crypto.subtle.digest("SHA-256", enc.encode(str));
  return "sha256-" + btoa(String.fromCharCode(...new Uint8Array(buf)));
}
